import { Dialog, makeStyles, DialogContent, DialogContentText, DialogActions, useMediaQuery, DialogTitle, } from '@material-ui/core';
import React, { useState } from 'react';
import { Close } from '@next-common/material-ui-icons';
import { globalTheme } from '../../theme';
const defaultProps = {
    withCloseIcon: false,
    isOpen: false,
    isBackdropClickDisabled: false,
    darkBgModal: false,
    withFullWidthBody: false,
    dataQa: "",
    onCloseCallBack: () => undefined,
    overlayStyle: {},
    footerStyle: {},
    bodyStyle: {},
    titleStyle: {},
    dialogContentStyle: {},
    contentTextStyle: {},
    extraClassName: ""
};
export const MuiModal = ({ withCloseIcon, isOpen, onCloseCallBack, children, dataQa, isBackdropClickDisabled, title, footer, overlayStyle, titleStyle, bodyStyle, footerStyle, dialogContentStyle, contentTextStyle, extraClassName }) => {
    const [open, setOpen] = useState(isOpen);
    const [scroll, setScroll] = React.useState('paper');
    const useStyles = makeStyles(() => ({
        overlay: overlayStyle,
        closeIcon: {
            position: 'absolute',
            top: '16px',
            right: '24px',
            cursor: 'pointer',
            zIndex: 99999999999,
            background: 'rgba(255, 255, 255, 0.4)',
            borderRadius: '5px',
        },
        body: bodyStyle,
        footer: footerStyle,
        title: titleStyle,
        dialogContent: dialogContentStyle,
        contentText: contentTextStyle,
        root: {
            background: "none"
        }
    }));
    const classes = useStyles();
    const theme = globalTheme();
    const fullscreen = useMediaQuery((theme.breakpoints.down('sm')));
    const onCloseDefault = () => {
        setOpen(false);
        if (onCloseCallBack) {
            onCloseCallBack();
        }
    };
    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);
    return (React.createElement(Dialog, { scroll: scroll, classes: { root: classes.root }, className: extraClassName ? extraClassName : '', open: open, onClose: onCloseDefault, disableBackdropClick: isBackdropClickDisabled, BackdropProps: { className: classes.overlay }, PaperProps: { className: classes.body }, fullScreen: fullscreen, onBackdropClick: isBackdropClickDisabled ? onCloseDefault : () => undefined },
        title && (React.createElement(DialogTitle, { className: classes.title },
            title,
            withCloseIcon
                && (React.createElement(Close, { className: classes.closeIcon, onClick: onCloseDefault })))),
        React.createElement(DialogContent, { className: classes.dialogContent, "data-qa": dataQa !== null && dataQa !== void 0 ? dataQa : null, dividers: !!title && scroll === 'paper' },
            withCloseIcon
                && !title && (React.createElement(Close, { className: classes.closeIcon, onClick: onCloseDefault })),
            React.createElement(DialogContentText, { className: classes.contentText, id: "scroll-dialog-description", ref: descriptionElementRef, tabIndex: -1 }, children)),
        footer && (React.createElement(DialogActions, { className: classes.footer }, footer))));
};
MuiModal.defaultProps = defaultProps;
